import React, { useContext } from 'react'
import { Route, Redirect, RouteProps } from 'react-router-dom'
import {AccountContext} from './../User/Account';
import { LoadingSpinner } from '../../layouts/utils/LoadingSpinner'


interface PrivateRouteProps extends RouteProps {

}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ ...otherProps }) => {

    const { isAuthenticated, isLoading } = useContext(AccountContext)

    if (!isAuthenticated) return <Redirect to='/' />
 
    return (
        <Route
            {...otherProps}
        />
    )

}


export default PrivateRoute